var _defs, _g, _g2, _g3, _g4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg180StreakMilestone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-17);}.cls-1,.cls-2,.cls-3,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8,.cls-9,.cls-10,.cls-11,.cls-12,.cls-13,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-21,.cls-22,.cls-23,.cls-24,.cls-25,.cls-26,.cls-27,.cls-28,.cls-29,.cls-30,.cls-31{stroke-width:0px;}.cls-2{fill:url(#linear-gradient-19);}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-15);}.cls-4,.cls-7,.cls-10,.cls-11,.cls-18,.cls-22,.cls-26,.cls-27,.cls-32,.cls-29,.cls-31{isolation:isolate;opacity:.52;}.cls-5{fill:url(#linear-gradient-21);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-5);}.cls-9{opacity:.53;}.cls-9,.cls-13{fill:#151c2b;}.cls-10{fill:url(#linear-gradient-13);}.cls-11{fill:url(#linear-gradient-10);}.cls-12{fill:url(#linear-gradient-23);}.cls-14{fill:url(#linear-gradient-25);}.cls-15{fill:url(#linear-gradient-22);}.cls-16{fill:url(#linear-gradient-20);}.cls-17{fill:url(#linear-gradient-2);}.cls-18{fill:url(#linear-gradient-9);}.cls-19{fill:url(#linear-gradient-3);}.cls-20{fill:url(#linear-gradient-27);}.cls-21{fill:url(#radial-gradient);}.cls-22{fill:url(#linear-gradient-14);}.cls-23{fill:url(#linear-gradient-24);}.cls-24{fill:url(#linear-gradient-26);}.cls-25{fill:url(#linear-gradient-18);}.cls-26{fill:url(#linear-gradient-8);}.cls-27{fill:url(#linear-gradient-16);}.cls-28{fill:url(#linear-gradient-28);}.cls-29{fill:url(#linear-gradient-11);}.cls-30{fill:url(#linear-gradient-4);}.cls-31{fill:url(#linear-gradient-12);}"), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 250,
    cy: 414.99,
    fx: 250,
    fy: 414.99,
    r: 224.76,
    gradientTransform: "translate(0 329.61) scale(1 .21)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#02adef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "rgba(2,173,239,.89)",
    stopOpacity: 0.89
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "rgba(2,173,239,.6)",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "rgba(2,173,239,.14)",
    stopOpacity: 0.14
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#02adef",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 154.88,
    y1: 365.82,
    x2: 137.27,
    y2: 380.19,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02adef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151c2b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 357.13,
    y1: 359.66,
    x2: 362.56,
    y2: 373.42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02adef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151c2b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 358.29,
    y1: -773.62,
    x2: 356.25,
    y2: -676.03,
    gradientTransform: "translate(0 926)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00aeef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00a2d3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 318.81,
    y1: -787.67,
    x2: 318.41,
    y2: -777.26,
    gradientTransform: "translate(0 926)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5f8d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00aeef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 295.3,
    y1: 433.88,
    x2: 295.3,
    y2: 74.16,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 250,
    y1: 433.88,
    x2: 250,
    y2: 74.16,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 233.58,
    y1: -582.1,
    x2: 303.73,
    y2: -582.1,
    gradientTransform: "translate(0 926)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#009fe3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#52caf5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 124.48,
    y1: -638.59,
    x2: 221.17,
    y2: -638.59,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 314.05,
    y1: -613.81,
    x2: 345.65,
    y2: -613.81,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 332.83,
    y1: -609.34,
    x2: 364.54,
    y2: -609.34,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 213.61,
    y1: -621.72,
    x2: 280.55,
    y2: -621.72,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 211.6,
    y1: -693.64,
    x2: 235.52,
    y2: -693.64,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 324.08,
    y1: -688.74,
    x2: 373.76,
    y2: -688.74,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 206.8,
    y1: -603.01,
    x2: 231.27,
    y2: -603.01,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 201.45,
    y1: -570.26,
    x2: 246.53,
    y2: -570.26,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 283.09,
    y1: -667.76,
    x2: 316.89,
    y2: -667.76,
    xlinkHref: "#linear-gradient-7"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 325.09,
    y1: -717.63,
    x2: 330.74,
    y2: -592.03,
    gradientTransform: "translate(0 926)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fffcd9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36c6f4",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 255.68,
    y1: -708.02,
    x2: 257.84,
    y2: -659.94,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 268.28,
    y1: -788.69,
    x2: 270.71,
    y2: -734.55,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 155.31,
    y1: -699.78,
    x2: 148.2,
    y2: -515.27,
    gradientTransform: "translate(128.87 945.05) rotate(-11.75)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 166.08,
    y1: 211.74,
    x2: 166.08,
    y2: 359.6,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 250.16,
    y1: 211.74,
    x2: 250.16,
    y2: 359.6,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 335.12,
    y1: 211.74,
    x2: 335.12,
    y2: 359.6,
    gradientTransform: "matrix(1,0,0,1,0,0)",
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 217.94,
    y1: -650.07,
    x2: 211.7,
    y2: -488.25,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 304.53,
    y1: -637.67,
    x2: 298.95,
    y2: -492.86,
    gradientTransform: "translate(-99.08 863.54) rotate(10.46)",
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 188.14,
    y1: 381.33,
    x2: 176.79,
    y2: 404.04,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02adef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151c2b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 243.93,
    y1: 399.09,
    x2: 244.65,
    y2: 411.04,
    xlinkHref: "#linear-gradient-26"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 312.85,
    y1: 383.9,
    x2: 319.75,
    y2: 399.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#02adef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#087dae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#0d5375"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#11354d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#142234"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#151c2b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 250,
    cy: 414.99,
    rx: 234.25,
    ry: 53.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M127.1,389.96s-11.7-34.45-6.08-34.23c5.62.22,37.65,18.5,37.65,18.5l3.38,23.83-34.95-8.1Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 250,
    cy: 404.77,
    rx: 140.53,
    ry: 32.05
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M375.7,392s17.13-32.1,11.54-32.79-52.82,15.03-52.82,15.03l5.48,20.1,35.8-2.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M353.23,166.2s6.1,22.61-2.69,31.39c13.97,2.93,21.65-31.39,2.69-31.39Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 318.64,
    cy: 142.91,
    r: 4.75
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M296.37,87.58s6.53,10.61-4.27,27.79c-10.85,17.19-19.11,27.65-6.53,40.23,2.69-9.5,6.19-20.35,14.21-24.63,17.62-9.41,14.07-37.49-3.41-43.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M373.64,300.2c.55,15.96-17.61,33.56-23.66,27.51-1.14-1.14-1.67-2.2-1.74-3.24-.43-6.43,8.32-9.92,14.05-17.13,11.75-14.79-2.17-31.3,9.67-43.62,4.73-4.92,9.63-5.08,14.78-12.98,1.53-2.35,4.23-6.6,4.69-12.26.96-11.96-8.91-20.67-10.45-21.99,1.41,5.08,2.53,12.5-1.08,18.74-3.98,6.89-10.82,7.33-17.44,12.7-5.23,4.23-11.25,12.28-13.02,29.16,0,0,.55-4.95,0-23.11s-11-23.66-12.65-39.06c-1.65-15.41,3.85-17.61-5.5-34.66-9.35-17.06-37.41-20.36-37.41-20.36,27.51,14.85,11.5,54.47,6.05,61.25-5.45,6.78-8.8,18.53-5.77,23.56,3.04,5.04.26,23.02-12.39,20.82-12.65-2.2-5.5-19.81,3.85-28.06,9.35-8.25,10.45-18.16,6.05-41.26-4.4-23.11-23.11-26.41-34.11-37.41-11-11-.55-24.76,8.8-34.66,9.35-9.9,5.5-24.21,5.5-24.21-1.65,7.15-19.26,22.56-18.47-1.1s29.47-34.11,29.47-34.11c0,0-22.01-3.3-34.89,6.05s-17.38,52.27-33.33,47.87c-15.96-4.4,2.75-23.11,2.75-23.11,0,0-16.51-3.85-30.81,18.71-14.3,22.56,8.8,31.36,17.06,51.17,8.25,19.81-6.05,34.66-23.66,33.56-17.61-1.1-13.75-29.71-13.75-29.71-17.61,28.61-2.2,40.16,10.99,54.19s7.71,35.49-3.29,45.4c-11,9.9-21.46,1.1-20.4-20.91,1.05-22.01-27.34-35.76-27.34-35.76,11.68,14.3,11.43,35.21,0,46.77-11.43,11.55-12.23-19.81-12.23-19.81,0,0-18.71,15.96-14.49,39.61,4.22,23.66,22.19,19.81,17.24,34.7-4.95,14.9-17.06-4.99-17.06-4.99.02,6.38.85,24.66,12.78,36.83,4.1,4.18,7.89,8.05,14.21,10.67,7.04,2.92,12.67,2.4,15.57,7.1,1.22,1.98,2.04,5.04.8,7.19-1.8,3.11-7.82,4.16-14.64,1.26,61.94,50.91,103.1,54.67,103.1,54.67,9.32,1.65,15.65,1.76,16.5,1.76,3.37,0,43.87-.61,76.42-29.3.05,0,.08-.01.09-.02.08-.07.35-.33.74-.72,1.42-1.28,2.83-2.61,4.22-4.01,1.58-1.59,3.05-3.16,4.41-4.7,11.19-11.38,29.2-29.93,35.94-37.8,9.9-11.55,17.61-20.91,17.61-37.92s13.75-29.2,13.75-29.2c0,0-28.06,0-27.51,15.96Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer_6",
    className: "cls-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M302.01,341.55c-1.03-3.12-2.58-6.14-4.02-9.15-1.48-3.09-3.16-5.92-5.21-8.72-3.98-5.45-6.56-11.51-10.26-17.11-2.09-3.16-4.23-6.21-5.83-9.59-1.64-3.41-3.16-6.9-4.43-10.46-2.42-6.79-3.65-14.09-3.49-21.21,0-.36-.57-.44-.7-.07-.9,2.72-1.68,5.59-1.56,8.46.12,2.91.57,5.81,1.23,8.68,1.44,6.03,3.86,11.88,6.44,17.58,1.35,3.01,2.17,6.21,3.24,9.3,1.07,3.09,2.54,5.99,3.86,9.01,1.23,2.8,2.17,5.7,2.99,8.57.45,1.6.74,3.12,1.31,4.72.53,1.49,1.11,3.01,1.6,4.5.98,2.94,1.64,5.88,2.3,8.9.7,3.09,1.11,4.76,1.15,7.95.08,5.45-1.56,10.17-4.39,14.93-3.12,5.27-6.81,10.31-10.54,15.22-.94,1.23-1.89,2.47-2.87,3.67-.53.65-1.07,1.27-1.6,1.89-.45.51-.12.11,0,.04-.29.33-.57.62-.86.94-2.01,2.18-4.1,4.29-6.28,6.32-2.34,2.18-4.8,4.25-7.34,6.25-1.27.98-2.58,1.96-3.9,2.91-.25.18-.53.36-.78.58-.16.11-.25.18-.37.25-.04.04-.12.07-.21.15-.62.44-1.27.84-1.93,1.27-3.2,2.07-5.7,3.74-8.82,6.32-2.5,2.03-4.43,4.47-6.73,6.65-.94.87-.33,2.61,1.19,2.51,3.08-.18,6.15-.18,9.15-.87,3.28-.76,6.48-1.96,9.39-3.49,5.66-2.98,10.91-6.94,15.71-10.89,10.05-8.28,17.8-18.45,24.86-28.8,3.61-5.27,6.97-10.93,8.37-17,1.56-6.65,1.35-13.8-.7-20.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M221.07,254.72c-.12-3.96-.66-7.77-1.44-11.69-1.03-5.08-1.6-13.15-8.37-14.82-.33-.07-.53.29-.33.51,2.22,2.14,3.98,4.5,4.84,7.3.94,3.05,1.23,6.21,1.15,9.33-.12,3.56.08,7.12-.16,10.71-.25,3.63-1.19,7.3-2.17,10.82-1.93,6.9-5.91,13.15-10.67,18.81-4.55,5.41-9.44,10.6-14.15,15.91-10.13,11.29-19.77,22.95-25.97,36.39-5.25,11.4-7.67,24.51-4.72,36.68-.12-.15-.29-.29-.41-.44-1.07-1.16-1.39-1.53-2.5-2.94-.94-1.23-1.85-2.54-2.67-3.85-2.79-4.54-4.76-10.06-5.66-15.87.04.15-.12-1.16-.16-1.38-.08-.69-.12-1.42-.16-2.14-.08-1.53-.12-3.05-.12-4.58,0-1.42.08-2.83.21-4.29.04-.73.12-1.42.21-2.14.04-.4.08-.8.16-1.2,0-.11.04-.22.04-.29,1.07-6.43,3.12-12.64,5.54-18.78,2.42-6.14,5.09-11.77,7.88-17.58,2.99-6.25,5.78-12.57,8.66-18.88.78-1.74,1.6-3.52,2.34-5.27.66,1.78,1.19,3.56,1.64,5.34,1.48,5.88,2.42,12.38-.08,18.16-.25.51.74.91,1.03.4,2.54-4.65,3.82-9.22,3.94-14.38.12-5.12-.98-10.24-2.46-15.18-.29-.91-.57-1.82-.9-2.69.94-2.43,1.97-4.79,2.71-7.3,2.17-7.08,3.24-14.56.21-21.57-.12-.25-.66-.25-.62.07.66,6.83-2.34,13.58-5.13,19.83-.16.36-.33.76-.49,1.13-2.71-5.63-6.07-11.04-9.76-16.23-6.11-8.61-12.96-16.74-19.4-25.17-6.07-7.99-11.53-16.2-11.2-26.15.16-4.87,1.68-10.02,4.1-14.38,2.63-4.72,6.44-8.61,10.83-12.17.33-.25-.08-.73-.45-.54-8.62,4.32-16.04,12.13-19.57,20.3-4.14,9.66-2.46,19.61,3.04,28.51,5.58,9.04,12.88,17.36,19.65,25.75,6.56,8.13,13.05,16.6,18.01,25.6.41.73.78,1.45,1.19,2.22l-.25.44c-1.85,3.05-3.69,6.14-5.58,9.19-3.65,5.92-7.75,11.58-11.4,17.5-3.73,6.1-7.02,12.38-9.93,18.81-5.42,12.02-8.37,25.6-6.81,38.57.82,6.68,2.58,13.07,5.87,19.14,3.08,5.67,7.63,10.68,12.55,15.18,5.46,4.94,11.9,8.82,17.6,13.55,5.37,4.47,10.83,9.88,18.17,11.62,1.6.4,2.91-1.34,1.93-2.47,1.97.44,4.02.58,5.95.25,1.56-.25,1.68-2.25.41-2.91-1.48-.76-2.5-1.45-3.24-2.8-.78-1.42-1.85-2.8-2.83-4.1-2.26-3.01-5.25-5.48-8-8.13-2.79-2.69-4.47-4.5-6.56-7.52-2.13-3.05-2.95-4.76-3.98-7.84-.49-1.49-.9-3.01-1.23-4.54-.08-.4-.16-.76-.21-1.16.04.25.12.98-.04-.22-.08-.76-.16-1.56-.25-2.32-.25-3.27-.08-6.54.37-9.77v-.04s.04-.11.04-.22c.08-.4.12-.8.21-1.2.12-.69.29-1.38.45-2.07.41-1.78.9-3.52,1.48-5.27.49-1.45,1.03-2.91,1.6-4.32.7-1.74,1.19-2.8,1.76-3.92,6.36-12.57,16.2-23.61,24.94-34.94,8.94-11.62,16.86-24.26,18.91-38.39.74-4.03.57-7.99.45-11.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M341.39,231.37c-.16-.4-.94-.4-.9.11.41,5.67,1.85,11.19.82,16.89-.98,5.45-4.72,10.28-8.08,14.78-3.32,4.43-6.85,8.79-9.93,13.4-3.16,4.72-5.74,10.1-7.43,15.36-3.61,11.37-1.31,22.77,3.04,33.7,2.09,5.27,4.55,10.39,6.56,15.69,2.05,5.41,3.57,10.82,4.64,16.45.53,2.8.74,5.63.74,8.5s-1.07,5.88-2.22,8.61c-2.5,5.85-5.78,11.88-10.01,16.89-.78.91.98,2.14,1.81,1.23,4.02-4.29,7.26-9.04,10.54-13.76,3.24-4.68,6.89-9.51,8.62-14.82,3.82-11.77-1.39-23.82-6.11-34.72-2.3-5.3-4.55-10.6-6.07-16.12-1.31-4.9-1.64-10.53-.98-15.14.78-5.16,2.63-10.28,4.96-15.04,2.46-5.01,4.92-10.02,7.71-14.89,1.6-2.83,3.28-5.67,4.59-8.64,1.31-2.98,1.81-6.06,1.93-9.22.29-6.43-1.56-13.36-4.23-19.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M359.16,355.68c.7-2.94,1.19-5.92,1.56-8.9-2.58-4.98-6.07-9.66-9.23-14.27-4.35-6.28-8.29-12.6-10.83-19.65-2.05-5.67-4.43-12.2-3.12-18.19,1.44-6.5,5.66-12.35,11.36-16.6.25-.18-.08-.51-.33-.4-5.99,2.4-9.68,6.94-12.02,12.27-1.19,2.76-1.85,5.67-2.58,8.53-.78,2.94-1.27,5.99-1.11,9.04.49,7.48,4.23,14.56,8.25,21.03,4.23,6.72,9.6,12.71,14.03,19.32,1.68,2.51,3.04,5.12,4.02,7.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M280.43,191.89c-7.26,1.31-14.48,3.6-20.18,7.95-5.83,4.43-10.75,10.13-14.11,16.23-8.37,15.14-8.45,33.05-5.21,49.32,1.76,8.9,3.57,17.72,6.07,26.47,2.42,8.39,4.8,16.89,5.95,25.53,1.11,8.35,1.11,16.81-.04,25.17-1.15,8.17-3.53,16.16-6.36,24.01-3.2,8.86-7.84,17.07-13.78,24.73-3.08,3.96-6.48,7.7-9.68,11.58-3.2,3.85-5.99,7.92-9.19,11.73-1.07,1.27,1.23,2.76,2.46,1.67,3.32-2.91,6.93-5.59,10.13-8.61,3.32-3.12,6.28-6.54,9.23-9.95,5.7-6.65,11.12-13.65,15.63-20.99,9.15-14.85,13.29-31.52,13.09-48.41-.25-17.61-5.46-35.23-11.2-52.01-1.44-4.18-2.83-8.32-3.77-12.64-.98-4.39-1.56-8.79-2.3-13.22-1.44-8.32-1.15-16.81,1.03-25.02,1.97-7.34,5.7-14.6,11.28-20.34,5.54-5.7,12.64-11.11,21-13,.12-.07.08-.22-.04-.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M231.49,242.37c-2.26-6.83-5.29-13.51-8.29-20.12-2.95-6.46-6.36-12.71-7.92-19.61-1.64-7.23-.33-14.49,3.82-20.92.12-.15-.12-.33-.29-.18-5.09,3.92-6.85,9.77-7.18,15.58-.33,6.83,1.81,13.47,4.18,19.87,5.05,13.73,11.81,26.77,14.81,41.04,1.64,7.88,1.72,16.34-.41,24.19-.29,1.05,1.39,1.45,1.85.44,5.54-13.11,3.73-27.13-.57-40.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M365.51,250.07c-5.54-10.57-12.8-20.52-20.59-29.89-7.51-8.97-16.25-18.19-16.49-29.96-.25-12.64,9.27-22.88,21.78-28.07.33-.15.08-.58-.25-.51-10.79,2.76-19.2,10.5-23.06,19.72-2.22,5.34-3.32,10.89-2.63,16.56.74,5.81,3.2,11.08,6.52,16.09,3.28,5.01,7.38,9.66,11.12,14.42,3.82,4.9,7.51,9.88,10.87,15.07,6.48,10.02,12.72,21.54,13.58,33.27.86,12.46-6.19,24.77-14.36,34.54-.78.94.98,2.18,1.85,1.27,7.84-8.28,16.12-16.96,18.91-27.75,3.08-11.98-1.56-23.9-7.26-34.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M228.86,320.12c-2.42-5.88-5.78-11.44-6.97-17.65-1.15-5.92-.29-13.11,4.31-17.83.12-.15-.08-.29-.21-.18-9.89,7.41-7.34,19.36-4.68,29.2,1.6,6.03,3.77,12.13,4.02,18.34.21,5.63-1.6,10.6-5.25,15.18-3.86,4.87-8.86,8.86-13.13,13.44-.49.54.29,1.27.86.76,8-7.15,18.21-13.04,22.24-22.88,2.26-5.63,1.11-12.89-1.19-18.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M244.9,327.06c-.62-2.4-1.15-4.83-2.09-7.15-.86-2.14-1.72-4.29-2.58-6.46-.9-2.25-1.93-4.36-3.24-6.43-1.48-2.32-2.42-4.98-3.53-7.48-.04-.11-.25-.07-.21.04.78,1.92,1.6,3.85,2.26,5.77.74,2.18.98,4.5,1.6,6.72,1.23,4.29,2.09,8.53,2.67,12.93.49,3.96.29,8.24-.29,12.2-.53,3.81-1.81,7.81-3.49,11.33-6.77,14.24-20.8,24.26-28.8,37.77-2.3,3.89-4.47,8.03-5.25,12.42-.74,4.1-.62,8.46.04,12.57.21,1.2,2.09.76,2.22-.25.25-1.85.57-3.81,1.27-5.59.74-1.85,1.93-3.63,2.87-5.37,1.89-3.45,4.14-6.9,6.65-10.06,5.09-6.43,10.71-12.46,16.08-18.67,5.29-6.1,10.13-12.57,13-19.9,1.52-3.85,2.3-7.77,2.42-11.84.16-4.36-.49-8.28-1.6-12.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M316.2,193.2c-3.9,2.72-6.97,6.17-10.13,9.55s-5.87,6.94-8.25,10.75c-4.84,7.74-9.64,15.65-11.9,24.37-4.59,17.47-3.61,36.03,3.77,52.8,2.42,5.48,5.58,10.75,8.66,15.98,1.44,2.47,3.41,4.68,4.47,7.34,1.15,2.87,2.09,5.99,2.5,9.01.08.47.82.51.86,0,.45-5.01-.12-9.91-.78-14.89-.66-4.87-2.46-9.62-4.18-14.27-3.08-8.28-6.24-16.96-7.26-25.31-1.07-8.32-.94-16.96.29-25.2.62-4.14,1.48-8.39,2.5-12.49,1.03-4.07,1.97-8.28,3.69-12.17,1.97-4.43,4.59-8.64,7.14-12.82,2.67-4.36,6.15-8.13,9.31-12.2.21-.36-.37-.65-.7-.44Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M363.04,377.61c0,.67-17.47-4.9-7.63-29.33,9.84-24.39,17.09-25.25,13.06-43.4-4.9,16.27-5.76,23.04-13.39,17.28-7.63-5.76-7.3-17.28,1.2-22.37,8.45-5.09,11.18-26.69-4.22-37.25,6.29,17.76,1.44,25.63-6.1,33.17-7.54,7.54-2.59,14.59-11.38,13.39s7.3-16.75-4.22-31.15c-9.17,16.08-15.75,14.59-23.23,4.56-7.49-10.03,19.63-30.34,18.96-49.49-.67-19.15-15.94-25.25-21.51-26.26,12.19,16.75,14.93,22.71,2.88,34.75-12.05,12.05-27.79,28.13-13.73,44.4,14.07,16.27,23.47,31.06,13.2,44.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M253.69,283.52s6.72-6.1-5.23-12.67c-11.95-6.53-22.66-18.87-7.2-34.32-2.5,15.79,3.31,22.8,14.31,18.53,10.99-4.27-9.55-35.48,23.67-39.08-13.78,16.03-17.38,30.29,0,60.77"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M253.45,211.71s10.37-2.69,1.82-20.11c-8.54-17.43-12.63-25.54,3.41-33.89-7.44,14.02-5.42,23.71,7.44,22.61,12.87-1.1,14.02-40.23-1.82-43.4,23.28-4.08,31.3,7.01,23.91,23.71-7.39,16.71-17.23,26.88,0,40.9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "NUMBERS"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M144.27,381.16c.19.89-11.45-21.84-9.46-38.88,2-17.04-2.49-43.56-11.16-24.89-8.35-11.4-3.12-27.25,6.53-32.98,9.64-5.73,16.11-42.33-2.42-57.16,27.11,7.31,28.24,37.03,22.54,52.97-5.71,15.94,2.08,18.25,9.94,12.69,4.46,21.43-4.05,23.45-4.05,23.45,0,0-14.59-13.59-15.11,8.44-.52,22.02,18.61,27.26,21.75,19.26,3.18-8.06-15.9-15.38.76-23.01-4.22,9.65,3.79,14.9,12.05,15.73,8.26.83,10.11,7.61,7.05,21.63-3.07,14.02,8.26,22.99,13.83,26.64,5.62,3.69-39.31.77-40.63,1.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M130.2,329.56v-26h22.08v-50.8h-19.04v-20.85l2.44-.46c10.58-1.99,17.69-4.61,24.53-9.01l.74-.48h22.12v81.6h18.88v26h-71.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M133.2,306.56h22.08v-56.8h-19.04v-15.36c11.04-2.08,18.4-4.8,25.6-9.44h18.24v81.6h18.88v20h-65.76v-20Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M249.84,331.48c-22.41,0-38.68-12.97-38.68-30.84,0-10.54,5.01-18.85,15.28-25.31-7.91-6.83-11.76-14.7-11.76-23.98,0-18.73,14.45-31.32,35.96-31.32s34.2,12.46,34.2,31c0,8.22-4.08,16.06-11.33,22,10.52,6.76,15.65,15.67,15.65,27.12,0,18.15-16.54,31.32-39.32,31.32ZM243.22,285.97c-3.02,3.48-4.78,7.77-4.78,11.79,0,7.32,5.97,10.6,11.88,10.6,4.47,0,9.8-1.56,9.8-9,0-5.84-5.49-8.55-16.9-13.39ZM250,243.16c-2.27,0-7.56.8-7.56,8.2,0,4.91,3.24,8.07,12.62,12.02,2.44-3.57,3.63-7.04,3.63-10.58,0-6.13-3.16-9.64-8.68-9.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M214.16,300.64c0-12.16,7.52-19.52,17.12-24.64v-.64c-8-5.92-13.6-13.44-13.6-24,0-17.44,13.76-28.32,32.96-28.32s31.2,11.04,31.2,28c0,9.6-6.24,17.28-13.28,21.92v.64c9.76,5.28,17.6,13.12,17.6,26.56,0,16.16-14.56,28.32-36.32,28.32-20.48,0-35.68-11.36-35.68-27.84ZM263.12,299.36c0-8.48-8.16-11.68-20.64-16.96-4,3.84-7.04,9.44-7.04,15.36,0,8.64,6.88,13.6,14.88,13.6,7.2,0,12.8-3.68,12.8-12ZM261.68,252.8c0-7.68-4.32-12.64-11.68-12.64-5.76,0-10.56,3.68-10.56,11.2s6.56,11.68,16.64,15.68c3.68-4.64,5.6-9.28,5.6-14.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M335.12,331.48c-12.07,0-22.13-5.13-29.12-14.85-6.99-9.72-10.68-24-10.68-41.27,0-34.64,14.88-55.32,39.8-55.32s39.8,20.68,39.8,55.32c0,17.28-3.69,31.55-10.68,41.27-6.98,9.71-17.05,14.85-29.12,14.85ZM335.12,245.24c-3.12,0-10.44,0-10.44,30.12s7.86,31.08,10.44,31.08c6.93,0,10.44-10.46,10.44-31.08,0-30.12-7.32-30.12-10.44-30.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M298.32,275.36c0-34.72,14.72-52.32,36.8-52.32s36.8,17.76,36.8,52.32-14.72,53.12-36.8,53.12-36.8-18.56-36.8-53.12ZM348.56,275.36c0-27.52-6.08-33.12-13.44-33.12s-13.44,5.6-13.44,33.12,5.92,34.08,13.44,34.08,13.44-6.72,13.44-34.08Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M216.36,412.79s-13.11-10.71-5.36-25.81c7.76-15.1,10.33-18.47,7.13-27.79-3.96,11.72-14.89,13.49-17.46-1.39-2.57-14.89,8.14-19.23,3.58-30.95-11.6,11.64-27.54-9.49-6.03-29.35-5.86,20.45,2.02,19.86,5.31,19.86-2.66-10.92-1.05-12.9,3.71-21.04,4.77-8.14,1.39-22.81-5.95-21.63,19.23-5.74,23.4,5.74,21.04,20.24-2.36,14.51-4.55,32.55,7.55,32.55-9.74,7.93-18.26-3.37-16.49-10.71-5.74-2.19-8.35,18.51,3.58,26.23,11.93,7.72,33.95,15.43,23.24,35.3-1.01-7.34-3.08-17.16-11.89-8.35-8.81,8.81-13.28,25.81,2.19,38.29,15.48,12.48,4.17,13.49,4.17,13.49l-18.34-8.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M283.63,417.44c-.17.9-22.92-17.31-24.58-52.77-1.66-35.45,15.57-39.16,19.5-41.9-12.69,19.04-6.71,30-6.71,30,0,0,2.21-15.65,16.42-25.48,14.2-9.78,5.99-41.17-5.84-44.28,32.92-.37,47.88,35.49,25.73,62.15,1.12-12.44-1.54-15.22-3.93-18.64-2.35-3.41-13.8,3.9-15.76,23.26-1.97,19.41,3.9,29.91-4.26,35.53,13.32,6.12,19.26-8.6,26.15-24.8,6.9-16.2,21.29-34.44,38.18-26.49-29.1,14.59-28.28,35-28.28,35,0,0,17.53-1.6,23.52-17.92,6.03,14.68-19,53.22-39.34,58.69-20.14,5.46-20.79,7.63-20.79,7.63Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ROCK_FRONT"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M127.1,389.96l15.71,13.49-5.26,15.01s30.3,23.07,53.76,13.18c23.46-9.88,23.27-7.32,23.27-7.32,0,0,16.37,8.62,34.54,6.14,18.17-2.49,24.54-4.76,24.54-4.76l21.64,5.94,69.02-23.78-5.06-11.29,16.43-4.57c-19.68-11.65-29.91-10.85-35.66-7.57-4.29,2.46-5.26,5.83-10.61,10.97-8.34,8.01-18.1,11.43-25.3,13.07-19.61,5.26-51.75,11.3-91.11,7.04-29.16-3.15-57.75-23.18-75.48-30.75-5.66-2.42-10.45,5.19-10.45,5.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M139.6,400.7c28.39,6.9,60.89,13.2,104.99,13.35,45.49.15,84-6.31,112.94-13.35-20.75,10.31-41.49,20.63-62.24,30.94l-16.07-11.84-62.88-3.51-25.04,15.35-51.71-30.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M137.55,418.46s0-40.28,12.88-45.13c12.88-4.85,30.02,20.9,30.02,20.9l32.87,26.2-75.77-1.97Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "217.76 419.8 250 400.7 269.31 403.12 272.42 416.67 217.76 419.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M288.69,420.79s6.81-29.94,10.21-29.94,28.09-4.74,28.09-4.74l37.33,21.75-75.63,12.93Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg180StreakMilestone);
export default __webpack_public_path__ + "static/media/180-streak-milestone.2694fc12d43927eccb18f18bce95ed7c.svg";
export { ForwardRef as ReactComponent };